import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconClockList32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconClockList32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5 16a8 8 0 1 1 16 0 8 8 0 0 1-16 0m8-10C7.477 6 3 10.477 3 16s4.477 10 10 10 10-4.477 10-10S18.523 6 13 6m1 5a1 1 0 1 0-2 0v6h4a1 1 0 1 0 0-2h-2zm14 3.4h-3.106a12 12 0 0 0-.443-2H28a1 1 0 0 1 0 2M28 9h-5.252a12 12 0 0 0-1.81-2H28a1 1 0 0 1 0 2m-3.106 8.6a12 12 0 0 1-.443 2H28a1 1 0 0 0 0-2zM22.748 23a12 12 0 0 1-1.81 2H28a1 1 0 0 0 0-2z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconClockList32);
